import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

import { Input } from '@/components/form/Input';
import { Button } from '@/components/ui/button';

interface HeaderRow {
  key: string;
  value: string;
}

interface StaticHeadersFormProps {
  label: string;
  onLabelChange: (label: string) => void;
  headers: HeaderRow[];
  onHeadersChange: (headers: HeaderRow[]) => void;
  showLabel?: boolean;
}

export function StaticHeadersForm({
  label,
  onLabelChange,
  headers,
  onHeadersChange,
  showLabel = true,
}: StaticHeadersFormProps) {
  const updateHeader = (index: number, field: 'key' | 'value', val: string) => {
    const updated = headers.map((h, i) =>
      i === index ? { ...h, [field]: val } : h
    );
    onHeadersChange(updated);
  };

  const addHeader = () => {
    onHeadersChange([...headers, { key: '', value: '' }]);
  };

  const removeHeader = (index: number) => {
    if (headers.length <= 1) return;
    onHeadersChange(headers.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-4">
      {showLabel && (
        <Input
          label="Label"
          name="static-header-label"
          value={label}
          onChange={e => onLabelChange(e.target.value)}
          placeholder="e.g. Production API Token"
          data-testid="static-header-label-input"
        />
      )}

      <div>
        <label className="text-chariot-text-primary mb-2 block text-sm font-medium">
          Headers
        </label>
        {headers.map((header, index) => (
          <div key={index} className="mb-2 flex items-end gap-2">
            <div className="flex-1">
              <Input
                name={`header-key-${index}`}
                placeholder={index === 0 ? 'Authorization' : 'Header name'}
                value={header.key}
                onChange={e => updateHeader(index, 'key', e.target.value)}
                data-testid={`header-key-${index}`}
              />
            </div>
            <div className="flex-1">
              <Input
                name={`header-value-${index}`}
                placeholder={index === 0 ? 'Bearer eyJ...' : 'Header value'}
                value={header.value}
                onChange={e => updateHeader(index, 'value', e.target.value)}
                data-testid={`header-value-${index}`}
              />
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => removeHeader(index)}
              disabled={headers.length <= 1}
            >
              <TrashIcon className="size-4" />
            </Button>
          </div>
        ))}
        <Button
          variant="ghost"
          size="sm"
          onClick={addHeader}
          data-testid="add-static-header-button"
        >
          <PlusIcon className="size-4" />
          Add Header
        </Button>
      </div>
    </div>
  );
}
